import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=54f580f2&scoped=true"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f580f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f580f2')) {
      api.createRecord('54f580f2', component.options)
    } else {
      api.reload('54f580f2', component.options)
    }
    module.hot.accept("./delete.vue?vue&type=template&id=54f580f2&scoped=true", function () {
      api.rerender('54f580f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/settings/schedule/delete.vue"
export default component.exports